export default "__VITE_ASSET__Bi_ZNy5Q__"